import {FC} from 'react';
import {getMyTaxLoadErrorDescription, getMyTaxLoadErrorTitle, RegistrationWorkStatus} from '../../model';
import {MyTaxAccessWarningIcon} from 'shared/assets/icons';
import {StepLayout} from 'features/registration';
import styles from './MyTaxLoadErrorStep.module.css';

type Props = {
	workStatus: RegistrationWorkStatus | null;
};

export const MyTaxLoadErrorStep: FC<Props> = ({workStatus}) => {
	return (
		<StepLayout variant="fill" className={styles.root}>
			<StepLayout.Intro
				title={getMyTaxLoadErrorTitle(workStatus)}
				subtitle={getMyTaxLoadErrorDescription(workStatus)}
			/>

			<StepLayout.Illustration>
				<MyTaxAccessWarningIcon className={styles.warningIcon} />
			</StepLayout.Illustration>
		</StepLayout>
	);
};
